module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Italic-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Italic-webfont.svg
// module id = 1615
// module chunks = 0